import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { UsuarioFranquiaRfariasListarComponent } from './usuario-franquia-rfarias-listar.component';

@NgModule({
 
  imports: [
    CommonModule,    
    TableModule,
    HttpClientModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule
  ],
  declarations: [
    UsuarioFranquiaRfariasListarComponent
  ],
  exports: [
    UsuarioFranquiaRfariasListarComponent
  ]
})
export class UsuarioFranquiaRfariasListarModule { }
